module.exports = __webpack_public_path__ + "img/663-0b8752.png";